import { render, staticRenderFns } from "./JgpAdvSite.vue?vue&type=template&id=5f866408&"
import script from "./JgpAdvSite.vue?vue&type=script&lang=js&"
export * from "./JgpAdvSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports